import React from 'react'

export default function Services() {
  return (
    <>
    <div className="service-top">
          <h1>OUR SERVICES</h1>
    </div>
    
      <div className="service-container">
        <div className="service-box">
          <div className="service-items">
            <img src="../img/img01.jpg" alt="" />
            <h1>Bridal Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img02.jpg" alt="" />
             <h1>Bridal Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img03.jpg" alt="" />
             <h1>Bridal Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img04.jpg" alt="" />
             <h1>Bridal Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img005.jpg" alt="" />
             <h1>Bridal Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img06.jpg" alt="" />
             <h1>Bridal Makeups</h1>
          </div>


          <div className="service-items">
            <img src="../img/img07.jpg" alt="" />
            <h1>Classic Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img08.jpg" alt="" />
            <h1>Classic Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img09.jpg" alt="" />
            <h1>Classic Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img10.jpg" alt="" />
            <h1>Classic Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img11.jpg" alt="" />
            <h1>Classic Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img12.jpg" alt="" />
            <h1>Classic Makeups</h1>
          </div>

          <div className="service-items">
            <img src="../img/img13.jpg" alt="" />
            <h1>Party Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img14.jpg" alt="" />
            <h1>Party Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img15.png" alt="" />
            <h1>Party Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img16.jpg" alt="" />
            <h1>Party Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img17.jpg" alt="" />
            <h1>Party Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img18.png" alt="" />
            <h1>Party Makeups</h1>
          </div>

          <div className="service-items">
            <img src="../img/img19.jpg" alt="" />
            <h1>Traditional Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img20.jpg" alt="" />
            <h1>Traditional Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img21.webp" alt="" />
            <h1>Traditional Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img22.jpg" alt="" />
            <h1>Traditional Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img23.jpg" alt="" />
            <h1>Traditional Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img24.png" alt="" />
            <h1>Traditional Makeups</h1>
          </div>

          <div className="service-items">
            <img src="../img/img25.jpg" alt="" />
            <h1>Haldi Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img26.jpg" alt="" />
             <h1>Haldi Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img27.jpg" alt="" />
             <h1>Haldi Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img28.jpg" alt="" />
             <h1>Haldi Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img29.jpg" alt="" />
             <h1>Haldi Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img30.jpg" alt="" />
             <h1>Haldi Makeups</h1>
          </div>


          <div className="service-items">
            <img src="../img/img31.jpg" alt="" />
            <h1>Eyes Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img32.jpg" alt="" />
            <h1>Eyes Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img33.jpg" alt="" />
            <h1>Eyes Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img34.jpg" alt="" />
            <h1>Eyes Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img35.jpg" alt="" />
            <h1>Eyes Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img36.jpg" alt="" />
            <h1>Eyes Makeups</h1>
          </div>

          <div className="service-items">
            <img src="../img/img37.jpg" alt="" />
            <h1>Glam Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img38.jpg" alt="" />
            <h1>Glam Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img39.jpg" alt="" />
            <h1>Glam Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img40.png" alt="" />
            <h1>Glam Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img41.jpg" alt="" />
            <h1>Glam Makeups</h1>
          </div>
          <div className="service-items">
            <img src="../img/img42.jpg" alt="" />
            <h1>Glam Makeups</h1>
          </div>
          
          
        </div>
      </div>
    </>
  )
}
